import Label from '../../../components/Label';
import React, { ReactNode } from 'react';
import { ReadWritePermissions } from '../../../../Auth/components/PermissionGate';
import { IntlShape, useIntl } from 'react-intl';
import { ValidationResult } from '../../../../util/validation/interfaces';
import { getHelp } from '../../../../util/intl.utils';
import { InputMask, InputMaskChangeEvent } from 'primereact/inputmask';

interface LabelledInputMaskProps {
  id: string;
  value: string;
  permissions: ReadWritePermissions;
  validation: ValidationResult;
  onChange: (value: string) => void;
  label: string;
  tooltip?: string;
  tooltipOptions?: any;
  pattern?: string;
  disabled?: boolean;
  autoFocus?: boolean;
  className?: string;
  mask: string;
  placeholder?: string;
  required?: boolean;
}

export const WorkIssued = (props: LabelledInputMaskProps): ReactNode => {
  const intl: IntlShape = useIntl();
  return (
    <div className={`flex flex-column gap-2`}>
      <h4>
        <Label
          label={intl.formatMessage({id: `${props.label}.label`})}
          validation={props.validation}
          required={props.permissions?.required || props.required}
          htmlFor={props.id}
          help={getHelp(intl, `${props.label}.help`)}
        />
      </h4>
      <InputMask
        id={props.id}
        value={props.value}
        required={props.permissions?.required || props.required}
        invalid={props.validation && !props.validation?.valid}
        disabled={(props.permissions && !props.permissions.canWrite) || props.disabled}
        onChange={(e: InputMaskChangeEvent): void => props.onChange(e.target.value)}
        tooltip={props.tooltip}
        tooltipOptions={props.tooltipOptions}
        pattern={props.pattern}
        autoFocus={props.autoFocus}
        className={props.className}
        placeholder={props.placeholder ? props.placeholder : intl.formatMessage({id: `${props.label}.label`})}
        mask={props.mask}
        minLength={4}
        maxLength={8}
        onBlur={(event): void => {
          if (event.target.value.length === 4) {
            props.onChange(event.target.value + '0000');
          }
        }}
      />
    </div>
  );
};
